export default __webpack_public_path__ + "static/image 53-720c921be1c0af5078c65afa29830a9e.png";